// extracted by mini-css-extract-plugin
module.exports = {"root":"StreamsCalendar_root__2UrLh"};